import { Theme, css } from '@emotion/react';
import { Toast as ToastType } from '@tock/toast';

const width = 320;

export const toastsContainer = ({ zIndex }: Theme) => css`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-${width / 2}px);
  z-index: ${zIndex.tooltip};
  gap: 8px;
`;

export const toastItem =
  (width: number, type: ToastType['type']) =>
  ({ colors }: Theme) => css`
    display: grid;
    grid-template-columns: 25px auto 30px;
    gap: 8px;
    align-items: flex-start;
    background-color: ${colors.bgContrast};
    padding: 8px 4px 8px 8px;
    border-radius: 6px;
    width: ${width}px;
    border-left: 3px solid ${type === 'info' ? colors.bgSuccessBase : colors.bgDangerBase};
  `;

export const iconContainer = css`
  display: inline-flex;
  margin-top: 2px;
`;

export const typeContainer = css`
  padding-top: 4px;
  padding-bottom: 4px;
`;

export const messageTxt = ({ colors }: Theme) => css`
  color: ${colors.fgContrast};
  line-height: 1.2;
`;

export const dismissContainer = css`
  align-self: flex-start;
`;

export const dismissBtn = css`
  opacity: 0.5;
  padding: 0;
  &:hover {
    opacity: 0.7;
  }
`;

export const linkText = css`
  &:hover {
    cursor: pointer;
  }
`;
